import React, { Component } from 'react';

// Third Party Components
import {
  GoogleMap,
  Marker,
  withScriptjs,
  withGoogleMap,
} from 'react-google-maps';

class LocationMap extends Component {
  render() {
    const {
      location,
    } = this.props;

    return (
      <GoogleMap
        defaultZoom={10}
        defaultCenter={location} // Brazil
        defaultOptions={{
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        }}
      >
        <Marker position={location} />
      </GoogleMap>
    );
  }
}

LocationMap.propTypes = {};
LocationMap.defaultProps = {};

export default withScriptjs(withGoogleMap(LocationMap));
